import React, { Fragment, useState, useEffect } from 'react';

import { Button } from "react-bootstrap";
import { connect } from 'react-redux';
// import { submitForm } from './search/redux/actions/actions';
import { useTranslation } from 'react-i18next';
import Select2Wrapper from '../Select2Wrapper';
import Cookies from 'js-cookie';
import OmantelVisaHeader from './OmantelVisaHeader';
import '@fontsource/ibm-plex-sans/400.css';  // Regular weight
import '@fontsource/ibm-plex-sans/500.css';  // Medium weight
import '@fontsource/ibm-plex-sans/600.css';  // Semi-bold weight

const { config } = require('../api/api');

function OmantelVisaPayment() {
   

    const [options, setCountries] = useState([]);
    const base_url = config.baseURL;
    const redirect_url=config.redirectURL;
    const [searchResult,setSearchResult]=useState(null);
    const [orderData,setOrderData]=useState(null);
    const [userData,setUserData]=useState(null);
    const [loading,setLoading]=useState(false);
    const [vendorKey,setVendorkey]=useState(null);
    const [orderId,setOrderId]=useState(null);
    const [lnstr,setlnstr]=useState("en");


     // Translation
    
        const { t,i18n } = useTranslation();
    
        useEffect(()=>{
          const getVisaDetails=sessionStorage.getItem("visaInfo");
        
          if(getVisaDetails){
            const parseVisaInfo=JSON.parse(getVisaDetails);
          if(parseVisaInfo?.locale){
          i18n.changeLanguage(parseVisaInfo?.locale)
          setlnstr(parseVisaInfo?.locale);
          }
          }
        },[])
    
    
          // Function to update HTML dir attribute based on language
          const updateHtmlDirAttribute = () => {
            document.documentElement.dir = i18n.dir(); // Set document direction
          };
        
          // Update HTML dir attribute when component mounts and language changes
          useEffect(() => {
            updateHtmlDirAttribute();
          }, [i18n.language]);

    useEffect(() => {
      
        const postvData = { organization_name: "Omantel" };
        debugger
    
        if (vendorKey === '' || vendorKey === null || vendorKey === undefined) {
    
          debugger
          fetch(base_url + '/create_organization', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(postvData),
          })
            .then(response => response.json())
            .then(data => {
              setVendorkey(data.result[0].vendor_key);
              
            })
            .catch(error => {
              console.error('Error posting data:', error);
            });
    
    
        }
      }, [vendorKey]);


    useEffect(()=>{
      const search_result=sessionStorage.getItem("VisaSearchResult");
      if(search_result){
        const search_parse=JSON.parse(search_result);
        setSearchResult(search_parse);
      }

      const order_info=sessionStorage.getItem("order_data");
      if(order_info){
        const order_parse=JSON.parse(order_info);
        setOrderData(order_parse);
      }

      const order_id=sessionStorage.getItem("event_data");
      if(order_id){
        const order_id_parse=JSON.parse(order_id);
        setOrderId(order_id_parse?.orderId);
      }
        },[])


    const textLabel = {
        display: "flex",
        alignItems: "center",
        padding: ".375rem .75rem",
        marginBottom: "0",
        fontSize: "1rem",
        fontWeight: "400",
        lineHeight: "1.5",
        color: "#495057",
       flexWrap:"wrap",
        backgroundColor: "",

        borderRadius: ".25rem"
    }
    const labelStyle = {
        backgroundColor: "#FFF2E6",
        width: "50%",
        border: "1px solid #ced4da",
        borderTopLeftRadius: "5px",
        borderBottomLeftRadius: "5px"

    }

    useEffect(() => {
        const storedUserString = sessionStorage.getItem("userDataForVisa"); //sessionStorage.getItem('userData')
        if (storedUserString !== undefined) {
          const storedUser = JSON.parse(storedUserString);
          setUserData(storedUser);
        }
        else {
          alert("login session expired");
          window.location.href = '/';
        }
      }, []);

    const handleSubmit = async (e) => {
        debugger
        e.preventDefault();
        
        console.log(userData);
        console.log(searchResult);
        // console.log(searchData);
        setLoading(true);
        const rand = Math.floor(Math.random() * 90000000) + 10000000;
        const rnd = rand.toString();
        const  usrtok=userData?.access_token;
       const data = {
            // "user_token":usrtok,
           
            "order_id":orderId,
            "amount_cents": searchResult.fee,
            "reference_id": rnd,
            "is_live": "true",
            "first_name": orderData.first_name,
            "last_name":orderData.last_name,
            "phone_no": orderData.phone_no,
            "apartment": orderData.apartment || "",
            "floor": orderData.floor|| "",
            "street": orderData.street || "",
            "city": orderData.city || "",
            "state": orderData.state || "",
            "country": orderData.country,
            "email": orderData.email,
            "save_selection": "true",
            "redirection_url": base_url+"/payment_status_info",
            "currency": searchResult.currency,
            "description": "Payment visa **",
            // "payment_token": pkey,
             "vendor_key":vendorKey
          };
        //   setPdata(data);
    debugger
    if (vendorKey !== ''&&usrtok!=='') {
    
      fetch(base_url+'/generate_payment_link_omantel', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${usrtok}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then(response => response.json())
        .then(data => {
          debugger
          if(data.message==="success"){
            window.location.href = data.result?.client_url;
          }
    
          // setpKey(data.result.payment_token);
    
    
        })
        .catch(error => {
          console.error('Error posting data:', error);
        });
    
    }
    // console.log(pdata);
    // setLoading(false);
       
      };


    return (
      <>
      <OmantelVisaHeader />
        <div style={{backgroundColor:"#fafafa", height:"80vh",fontFamily: 'IBM Plex Sans' }}>
            <div className='container' >
            <h1 className='visa_page_heading' >
            {lnstr==="en"?"Make Payment":"قم بالدفع"}
                </h1>
                <div style={{ paddingTop: "50px" }}>
                    <form >
                        <div className='row' style={{backgroundColor:"#fafafa", display: "flex", alignContent: 'center', justifyContent: "center",marginBottom:"50px", paddingBottom:"100px" }}>


                            <div className='col-md-6'>
                               
<div className='card px-md-5 px-4 py-md-5 py-5 shadow'>
                                {/* First Name */}
                                <div className="input-group mb-2 mt-2">
                                    <div className="input-group-prepend " style={labelStyle}>
                                        <span style={textLabel}>{t("First")} {t("Name")}</span>
                                    </div>
                                    <input type="text" name="firstName" className="form-control"
                                        //    onChange={} 
                                        value={orderData?.first_name}
                                        style={{ backgroundColor: "#FFF2E6" }}
                                        disabled
                                         />
                                </div>

                                {/* Last Name */}
                                <div className="input-group mb-2 mt-2">
                                    <div className="input-group-prepend " style={labelStyle}>
                                        <span style={textLabel}>{t("Last")} {t("Name")}</span>
                                    </div>
                                    <input type="text" name="lastName" className="form-control"
                                        //    onChange={} 
                                        value={orderData?.last_name}
                                        style={{ backgroundColor: "#FFF2E6" }}
                                        disabled
                                         />
                                </div>
                                {/* Email */}
                                <div className="input-group mb-2 mt-2">
                                    <div className="input-group-prepend " style={labelStyle}>
                                        <span style={textLabel}>{t("Email")}</span>
                                    </div>
                                    <input type="text" name="email" className="form-control"
                                        //    onChange={} 
                                        value={orderData?.email}
                                        style={{ backgroundColor: "#FFF2E6" }}
                                        disabled
                                         />
                                </div>

                                {/* passport country */}
                                <div className="input-group mb-2 mt-2">
                                    <div className="input-group-prepend " style={labelStyle}>
                                        <span style={textLabel}>{t("Passport")} {t("Country")}</span>
                                    </div>
                                    <input type="text" name="passportCountry" className="form-control"
                                        //    onChange={} 
                                        value={searchResult?.citizenship}
                                        style={{ backgroundColor: "#FFF2E6" }}
                                        disabled
                                         />
                                </div>

                                 {/* destination country */}
                                 <div className="input-group mb-2 mt-2">
                                    <div className="input-group-prepend " style={labelStyle}>
                                        <span style={textLabel}>{t("Destination")} {t("Country")}</span>
                                    </div>
                                    <input type="text" name="destinationCountry" className="form-control"
                                        //    onChange={} 
                                        value={ searchResult?.destination}
                                        style={{ backgroundColor: "#FFF2E6" }}
                                        disabled
                                         />
                                </div>


                                {/* Fee  */}
                                <div className="input-group mb-2 mt-2">
                                    <div className="input-group-prepend " style={labelStyle}>
                                        <span style={textLabel}>{t("Fee")}</span>
                                    </div>
                                    <input type="text" name="Fee" className="form-control"
                                        //    onChange={} 
                                        value={searchResult?.fee}
                                        style={{ backgroundColor: "#FFF2E6" }}
                                        disabled
                                         />
                                </div>

                                   {/* currency  */}
                                   <div className="input-group mb-2 mt-2">
                                    <div className="input-group-prepend " style={labelStyle}>
                                        <span style={textLabel}>{t("Currency")}</span>
                                    </div>
                                    <input type="text" name="currency" className="form-control"
                                        //    onChange={} 
                                        value={searchResult?.currency}
                                        style={{ backgroundColor: "#FFF2E6" }}
                                        disabled
                                         />
                                </div>
                                {/* make payment btn */}
                                <div className="find_visa_btn"  style={{marginTop:"40px",display:"flex",justifyContent:"center"}}>
                       <button type="submit"  disabled={loading} onClick={handleSubmit}>
                           {!loading?
                           <span>
                           {lnstr==="en" ?"Make Payment":"قم بالدفع"} </span>:<div class="d-flex  justify-content-center" style={{padding:"0px 23px"}}><div class="omantel-loader"></div></div>}
                            </button>    
                            </div> 
                                </div>
                     
                            </div>
                        </div>
                      
                    </form>

                </div>
            </div>
            
        </div>
      </>
    )
}
export default OmantelVisaPayment;